import { render } from "./businessIcon.vue?vue&type=template&id=3ad37f98&scoped=true"
import script from "./businessIcon.vue?vue&type=script&lang=js"
export * from "./businessIcon.vue?vue&type=script&lang=js"

import "./businessIcon.vue?vue&type=style&index=0&id=3ad37f98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad37f98"]])

export default __exports__